// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import '@/utils/resize.js';
import dsbridge from 'dsbridge';
import Vconsole from 'vconsole';
import Cube from 'cube-ui';
import "@/assets/iconfont/iconfont.css";
import '@/assets/scss/base.scss';

Vue.use(Cube);
Vue.config.productionTip = false;
// 引入
if(location.origin !== 'https://h5.xiangdongcn.com' && location.origin !== 'http://h5.xiangdongcn.com') {
  new Vconsole();
}
new Vue({
  el: '#app',
  router,
  dsbridge,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js